import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Card } from 'app/components/card';
import { Image } from 'app/components/image';
import { breakpointTablet } from 'app/style/breakpoints';
import { spacing1, spacing2, spacing3, spacing4 } from 'app/style/spacing';

export const StyledHouseImage = styled(Image)`
    max-width: 100%;
    align-self: center;

    @media (min-width: ${breakpointTablet}) {
        max-width: 170px;
        margin: 0 auto ${spacing2};
    }
`;

export const StyledSingleMeshUnitImage = styled(Image)`
    max-width: 23px;

    &:not(:last-child) {
        margin-right: ${spacing1};
    }

    @media (min-width: ${breakpointTablet}) {
        max-width: 37px;

        &:not(:last-child) {
            margin-right: ${spacing2};
        }
    }
`;

export const StyledMeshUnitImageWrapper = styled.div`
    grid-row: 2;
    grid-column: 1;
    margin: auto;

    @media (min-width: ${breakpointTablet}) {
        grid-row: 3;
    }
`;

export const StyledBuildingCardContainer = styled.div`
    display: grid;
    grid-template-columns: fit-content(82px) 1fr;
    grid-template-rows: minmax(82px, auto) auto;
    grid-gap: 0 ${spacing2};
    margin-bottom: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        grid-template-columns: 1fr;
        grid-template-rows: unset;
        align-content: end;
        grid-gap: 0;
        margin-bottom: ${spacing4};
        min-height: 365px;
    }
`;

export const StyledInfoText = styled(Typography)`
    @media (min-width: ${breakpointTablet}) {
        text-align: center;
        margin-bottom: ${spacing2};
    }
`;

export const StyledDescription = styled(Typography)`
    grid-row: 2;
    grid-column: 2;

    @media (min-width: ${breakpointTablet}) {
        grid-row: 4;
        grid-column: 1;
        text-align: center;
        margin: ${spacing1} auto 0;
        max-width: 202px;
    }
`;

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    margin-bottom: ${spacing1};
    margin-top: ${spacing1};

    @media (min-width: ${breakpointTablet}) {
        margin-top: 0;
        grid-row: 2;
        text-align: center;
    }
`;

export const StyledCard = styled(Card)`
    margin: ${spacing1} 0;
`;
